
import * as React from 'react';
import { GenericHorizontalListComponentProps, GenericHorizontalListComponentState } from './genericlistcomponent';
import { GenericHorizontalListCSSStyle } from './genericlistcss';
import { UIComponentViewImpl } from '../../uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../uicomponent';
// var smoothscroll = require('smoothscroll-polyfill');
import * as smoothscroll from 'smoothscroll-polyfill';
import { BaseContext } from '../../../../utils/basecontext';
import './generic-horizontallist-style.css';

export class GenericHorizontalListViewImpl extends UIComponentViewImpl<UIDataModel>
{
    private listRef: any;

    constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(applicationContext, uiComponentHandler);
        
        smoothscroll.polyfill();
    }

    bindHandlers()
    {
        this.onClickLeft = this.onClickLeft.bind(this);
        this.onClickRight = this.onClickRight.bind(this);
        this.onScroll = this.onScroll.bind(this);
    }

    draw(props: GenericHorizontalListComponentProps, state: GenericHorizontalListComponentState, cssStyle: GenericHorizontalListCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
    
       return (
        <>
            <h2 style={props.titleCSSStyle}>{props.title}</h2>
            <div style={cssStyle.getGenericHorizontalListContainerCSSStyle()}>
            {state.isLeftArrowEnabled && <div id={props.length > 4 ? "generic-horizontal-left-arrow-more" : "generic-horizontal-left-arrow-less"} style={cssStyle.getLeftArrowDivCSSStyle(props.arrowsPaddingType)} onClick={this.onClickLeft}>
                    {/* <div style={cssStyle.getLeftArrowCSSStyle(props.arrowMarginTop)}/> */}
                    <img style={cssStyle.getLeftArrowCSSStyle(props.arrowMarginTop, props.arrowsSizeType)} src={props.arrowsType === undefined ? props.context.getResources().getImage("previous.svg") : props.context.getResources().getImage("previous"+ props.arrowsType +".svg")} height="30px"/>
                </div>}
                {state.isRightArrowEnabled && <div id={props.length > 4 ? "generic-horizontal-right-arrow-more" : "generic-horizontal-right-arrow-less"} style={cssStyle.getRightArrowDivCSSStyle(props.arrowsPaddingType)} onClick={this.onClickRight}>
                    {/* <div style={cssStyle.getRightArrowCSSStyle(props.arrowMarginTop)}/> */}
                    <img style={cssStyle.getRightArrowCSSStyle(props.arrowMarginTop, props.arrowsSizeType)} src={props.arrowsType === undefined ? props.context.getResources().getImage("next.svg") : props.context.getResources().getImage("next" + props.arrowsType + ".svg")} height="30px"/>
                </div>}
                <ol style={cssStyle.getOrderListCSSStyle()} ref={elm=>this.listRef=elm} onScroll={this.onScroll}>
                    {
                        (props.children.map!==undefined) &&
                        props.children.map((entry: any, index: number)=>
                        <li key={index} style={cssStyle.getListCSSStyle(props.gutterMargin)}>{entry}</li>)
                    }
                    {
                        (props.children.map===undefined)&&  
                        <li style={cssStyle.getListCSSStyle(props.gutterMargin)}>{props.children}</li>}
                </ol>
            </div>
        </>
       );
    }

    getListRef()
    {
        return this.listRef;
    }

    private onClickLeft()
    {
        let rootDiv = document.getElementById("root");

        if(this.listRef && rootDiv)
        {
            if(rootDiv.dir === "ltr")
            {
                this.listRef.scrollBy({left:Math.min(this.listRef.scrollLeft, 250)*(-1), behavior: 'smooth'});
            }
            else
            {
                this.listRef.scrollBy({left:Math.min(this.listRef.scrollLeft + this.listRef.scrollWidth, 250)*(-1), behavior: 'smooth'});
            }
        }
    }

    private onClickRight()
    {
        let rootDiv = document.getElementById("root");

        if(this.listRef && rootDiv)
        {
            if(rootDiv.dir === "ltr")
            {
                this.listRef.scrollBy({left:Math.min(this.listRef.scrollWidth - this.listRef.clientWidth, 250), behavior: 'smooth'});
            }
            else
            {
                this.listRef.scrollBy({left:Math.min(this.listRef.scrollWidth + this.listRef.clientWidth, 250), behavior: 'smooth'});
            }
        }
    }

    private onScroll()
    {
        // (this.getUIComponentHandler() as GenericHorizontalListComponentHandler).onScroll();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/horizontallist/generichorizontallist/genericlistview.tsx